import { render, staticRenderFns } from "./GrowingNumber.vue?vue&type=template&id=38b30938"
import script from "./GrowingNumber.vue?vue&type=script&lang=js"
export * from "./GrowingNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports